import apiSlice from 'renderer/shared/state/apiSlice';
import {
  DashboardGroupedDataResponse,
  DashboardGroupedDataResponseSchema,
  RecentUsersRequest,
  RecentUsersResponse,
  RecentUsersResponseSchema,
  RefundsRequest,
  RefundsResponse,
  RefundsResponseSchema,
} from '../schemas/dashboard.schemas';

const dashboardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch Grouped Data (Purchases, Users by Product, Platform, Host App)
    getDashboardGroupedData: builder.query<DashboardGroupedDataResponse, void>({
      query: () => ({
        url: '/dashboard/grouped-data',
        method: 'GET',
      }),
      providesTags: ['Dashboard'],
      extraOptions: {
        responseSchema: DashboardGroupedDataResponseSchema,
      },
    }),

    // Fetch Recent Users (Paginated)
    getRecentUsers: builder.query<RecentUsersResponse, RecentUsersRequest>({
      query: ({ page = 1, limit = 10 }) => ({
        url: `/dashboard/recent-users?page=${page}&limit=${limit}`,
        method: 'GET',
      }),
      providesTags: ['Dashboard', 'User'],
      extraOptions: {
        responseSchema: RecentUsersResponseSchema,
      },
    }),

    // Fetch Refunds (Paginated)
    getRefunds: builder.query<RefundsResponse, RefundsRequest>({
      query: ({ page = 1, limit = 10 }) => ({
        url: `/dashboard/refunds?page=${page}&limit=${limit}`,
        method: 'GET',
      }),
      providesTags: ['Dashboard', 'Refund'],
      extraOptions: {
        responseSchema: RefundsResponseSchema,
      },
    }),
  }),
});

export const {
  useGetDashboardGroupedDataQuery,
  useGetRecentUsersQuery,
  useGetRefundsQuery,
} = dashboardApi;

export default dashboardApi;
